<template>
  <div class="c-searchBar">
    <div class="c-searchBar__tab">
      <button @click="isSearchBodyComp = !isSearchBody">物件を絞り込む</button>
      <button v-if="$route.name !=='kodateDetail' && $route.name !== 'SchoolDistrictsCity'" class="p-gotoBottom" @click="clickSmoothScroll">市区町村から探す</button>
    </div>
    <div v-if=" isSearchBody" class="c-searchBar__tab--body">
      <h2>
        絞り込み検索
      </h2>
      <div class="c-searchBar__tab--body--code">
        <div class="u-selectWrapper u-mR8">
          <select v-model="options.prefcode" @change="onChangeCityList();isChanged= true">
            <option value=0 disabled>都道府県</option>
            <option v-for="(item, index) in preflist" :key="index" :value="item.pref_code">{{item.pref_name}}</option>
          </select>
        </div>
        <div class="u-selectWrapper">
          <select v-model="options.citycode" v-bind:disabled="!isCityListReady" @change="isChanged= true">
            <option value=0 disabled>市区町村選択</option>
            <option v-for="(item, index) in citylist" :key="index" :value="item.city_code">{{item.city_name}}</option>
          </select>
        </div>
      </div>
      <div>
        <h3>
          <img >価格帯
        </h3>
        <div>
          <div class="c-textCenter">
            <input type="checkbox" id="price" class="u-mL10 u-mR8" v-model="options.ask"><label for="price" @click="isChanged=true">価格未定の物件を表示する</label>
          </div>
          <div>
            <div class="u-modal--select">
              <select v-model="options.priceLow" @change="isChanged= true">
                <option v-for="(item, index) in optionList.priceLow" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
            〜
            <div class="u-modal--select">
              <select v-model="options.priceHigh" @change="isChanged= true">
                <option v-for="(item, index) in optionList.priceHigh" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3>
          間取り
        </h3>
        <div>
          <ul class="u-modal--checkbox">
            <li v-for="(item, index) in optionList.layout" :key="index">
              <input type="checkbox" :id="`layout-${item.value}`" v-model="options.layout" :value="item.value" style="display:none;" />
              <label :for="`layout-${item.value}`" :class="{ 'u-modal--checkbox__on': options.layout.includes(item.value)}" @click="isChanged=true">{{item.name}}</label>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <h3>
          土地面積
        </h3>
        <div>
          <div>
            <div class="u-modal--select">
              <select v-model="options.landAreaLow" @change="isChanged= true">
                <option v-for="(item, index) in optionList.areaLow" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
            〜
            <div class="u-modal--select">
              <select v-model="options.landAreaHigh" @change="isChanged= true">
                <option v-for="(item, index) in optionList.areaHigh" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3>
          建物面積
        </h3>
        <div>
          <div>
            <div class="u-modal--select">
              <select v-model="options.buildingAreaLow" @change="isChanged= true">
                <option v-for="(item, index) in optionList.areaLow" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
            〜
            <div class="u-modal--select">
              <select v-model="options.buildingAreaHigh" @change="isChanged= true">
                <option v-for="(item, index) in optionList.areaHigh" :value="item.value" :key="index">{{item.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div>
        <h3>
          徒歩
        </h3>
        <div class="u-modal--select u-modal--select__l u-mB10">
          <select v-model="options.walkin" @change="isChanged= true">
            <option v-for="(item, index) in optionList.walkin" :value="item.value" :key="index">{{item.name}}</option>
            <option value=999>上限なし</option>
          </select>
        </div>
        <input type="checkbox" id="byBus" class="u-mL10 u-mR8" v-model="options.byBus"><label for="byBus" @click="isChanged=true">徒歩分にバス乗車時間含む</label>
      </div>
      <div>
        <h3>フリーワード</h3>
        <input type="text"  v-model="options.fw" @change="isChanged= true" placeholder="フリーワード検索" />
      </div>
      <div class=" u-w260">
        <common-button
          :callback="update"
          :title="buttonText"
          :font_size="'14px'"
          :attr=[]
          :bg_red="true"
          :middle="true"
           />
      </div>
      <div v-if="isChanged && isMobile" class="u-w260 js-float">
        <common-button
          :callback="update"
          :title="buttonText"
          :font_size="'14px'"
          :attr=[]
          :bg_red="true"
          :middle="true" />
      </div>
      <div v-if="isSearchBody" class="u-w260" style="margin:20px auto;">
          <common-button
            :callback="()=>{isSearchBodyComp = !isSearchBody}"
            :title="'閉じる'"
            :font_size="'14px'"
            :attr=[]
            :border_gray="true"
            :middle="true" />
      </div>
    </div>

  </div>
</template>

<script>
import MixinAPI from '@/plugins/mixin-api';
import IsMobile from '@/plugins/isMobile';
import MixinSearchbar from '@/plugins/mixin-searchbar';
import CommonButton from '@/components/parts/button/CommonButton';

export default {
  name: 'SearchBarSp',
  mixins: [MixinAPI, IsMobile, MixinSearchbar],
  props: ['isSearchBody'],
  components: {
    CommonButton,
  },
  computed: {
    isSearchBodyComp: {
      get() {
        return this.isSearchBody;
      },
      set(isSearchBody) {
        this.$emit('input', isSearchBody);
      },
    },
  },
  methods: {
    clickSmoothScroll() {
      document.querySelector('.js-search-list').scrollTo({
        top: 100000,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/searchbar_scss.scss";
  button {
    margin: 0 10px;
    font-size:13px;
  }
  .p-gotoBottom {
    width: 100%;
    max-width:220px;
    height: 40px;
    margin: 0 10px;
    border: 1px solid #CCC;
    border-radius: 20px;
    display:flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: #FFF;
  }
  .p-gotoBottom:before {
    background-image: none;
  }
  .p-gotoBottom:after {
    content: '';
    // background-image: url('/static/img/icon-arrow.png');
    background-size: cover;
    transform:rotateZ(90deg);
    position: absolute;
    width: 18px;
    height: 18px;
    top:10px;
    right:25px;
  }
  .c-textCenter {
    display: flex !important;
    justify-content: center !important;
    min-width: auto !important;
  }


  @media(max-width: 767px) {
    .c-textCenter  {
      justify-content: flex-start !important;
    }
  }

</style>
